export default __webpack_public_path__ + "static/media/preorder_cover.5a7677ef.webp";